import { render, staticRenderFns } from "./DashboardWidgets.vue?vue&type=template&id=3f01526c"
import script from "./DashboardWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports